import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useGovernmentProjectsDispatch } from "./government-projects-context";
import { IListGovernmentProjectsRequest } from "../../../model/base/request/list-government-projects-request";

export const useGovernmentProjectsController = () => {
    const GovernmentProjectsDispatch = useGovernmentProjectsDispatch();

    async function loadData(request: IListGovernmentProjectsRequest) {
        try {
            GovernmentProjectsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: true,
            });

            const result = await PortalAppService.requestGovernmentProjects(request);

            GovernmentProjectsDispatch({
                type: ACTION_TYPES.setProjects,
                payload: result,
            });
        } catch (error) {
            console.error('Erro ao carregar projetos governamentais:', error);
            GovernmentProjectsDispatch({
                type: ACTION_TYPES.setLoading,
                payload: false,
            });
        }
    }

    return {
        loadData
    };
}
